import React from 'react';
import { userCircle } from '@amzn/storm-ui-icons';
import {
  IA2MobileUserIcon,
  MobileSideNavItemText,
  MoreToolsMenuItem,
} from './styles';
import { useSidenavBundle } from 'src/providers/PantherLocalizationProvider';

interface UserPreferenceMenuItemProps {
  handleClick: () => void;
}

export const UserPreferenceMenuItem: React.VFC<UserPreferenceMenuItemProps> = ({
  handleClick,
}) => {
  const bundle = useSidenavBundle();

  return (
    <MoreToolsMenuItem
      onClick={handleClick}
      aria-label={bundle.getMessage('sidenav-your-preferences-label')}
      data-takt-id={'aac-user-preferences'}
    >
      <IA2MobileUserIcon type={userCircle} size="lg" />
      <MobileSideNavItemText>
        {bundle.getMessage('sidenav-your-preferences-label')}
      </MobileSideNavItemText>
    </MoreToolsMenuItem>
  );
};
